document.addEventListener("DOMContentLoaded",(event)=>{
  document.querySelectorAll("input[data-product-option]").forEach(radio=>{
    radio.addEventListener("click",(event)=>{
        document.querySelector("#product-price-wrap .money").innerHTML = event.target.getAttribute("data-price");
        document.querySelector('#product-price-wrap-copy .money').innerHTML = event.target.getAttribute('data-price');
        let comparePrice = document.querySelector('#compare-at-price.money');

        if (comparePrice) {
          comparePrice.innerHTML = event.target.getAttribute('data-compare-at-price');
          document.querySelector('#compare-at-price-copy.money').innerHTML = event.target.getAttribute('data-compare-at-price');
        }
    });
  });
});
